import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

export function InfoTooltip({ text }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, above: false });
  const ref = useRef(null);

  const reposition = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const above = rect.bottom + 160 > window.innerHeight;
    setPos({
      top: above ? rect.top + window.scrollY - 8 : rect.bottom + window.scrollY + 8,
      left: rect.left + window.scrollX + rect.width / 2,
      above,
    });
  }, []);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [open]);

  const tooltip = open ? ReactDOM.createPortal(
    <div
      className={`info-tip-card ${pos.above ? 'info-tip-above' : ''}`}
      style={{
        position: 'absolute',
        top: pos.above ? undefined : pos.top,
        bottom: pos.above ? `calc(100vh - ${pos.top}px)` : undefined,
        left: pos.left,
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      <div className={`info-tip-caret ${pos.above ? 'info-tip-caret-below' : ''}`} />
      {text}
    </div>,
    document.body
  ) : null;

  return (
    <span
      className="info-tip"
      ref={ref}
      onMouseEnter={() => { reposition(); setOpen(true); }}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => { e.stopPropagation(); reposition(); setOpen(o => !o); }}
    >
      <span className="info-tip-trigger" aria-label="More information">?</span>
      {tooltip}
    </span>
  );
}
